module.exports = __webpack_public_path__ + "static/media/4-8.34928755.mp3";